import { useContext, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router';

import { PublicPackage } from '@drivingdoc/api-client/generated/types';

import { SchoolContext } from 'context/SchoolContext';

import useSentryFeedbackButton from 'hooks/useSentryFeedbackButton';

import MultiStepRegistrationForm from 'pages/Main/PackageListing/components/RegistrationForm';

function ExternalPackageRegistration(): JSX.Element {
  const { id } = useParams();
  const schoolContext = useContext(SchoolContext);
  const { hideFeedbackButton, showFeedbackButton } = useSentryFeedbackButton();

  const [pkg, setPkg] = useState<PublicPackage | undefined>();

  // simulate data fetch
  useEffect(() => {
    setPkg(schoolContext?.packages.find((item: PublicPackage) => item.id === id));
  }, [id, schoolContext?.packages]);

  useEffect(() => {
    // Hide the Sentry Feedback button when this component mounts
    hideFeedbackButton();

    // Restore it when the component unmounts
    return () => {
      showFeedbackButton();
    };
  }, [hideFeedbackButton, showFeedbackButton]);

  if (pkg === undefined) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box display="flex" justifyContent="center" minHeight="100vh">
      <Helmet>
        <title>{`Register | ${schoolContext?.name || schoolContext?.shortName || 'Driver Education'}`}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box flexGrow={1}>
        <MultiStepRegistrationForm package={pkg} />
      </Box>
    </Box>
  );
}

export default ExternalPackageRegistration;
